import {Button} from 'antd'
import {course_class_getAttendances_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsThreeDots} from 'react-icons/bs'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {DateNameSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CouseClassAttendanceFilter from 'views/Workspace/Course/components/filters/CouseClassAttendanceFilter'
import {renderCourseClassAttendance} from 'views/Workspace/Course/functions/renderCourseClassAttendance'
import {bindQueryParam} from '../../../functions/routerHelper'
import CourseClassContext from '../../CourseClassContext'
import {AiOutlineAudit} from "react-icons/ai";
import EmptyHolder from "../../../../../components/EmptyHolder";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {useRouteSearchParam} from "../../../../../envs/_current/history";
import {PiChartBarFill, PiUserListFill} from "react-icons/pi";
import {useCourseAttendances} from "../../functions/useCourseAttendances";
import {AttendanceActionTypes} from "../../index";
import {CourseClassStudentAttendanceStats, StudentAttendanceSessionList} from "../CourseClassAttendanceForm";
import classNames from "classnames"
import {CourseClassTabHeader} from "../components/CourseClassTabHeader"


const CourseClassAttendanceTab = ({
                                      filter_actions = {
                                          sortBy: 'sort-by',
                                          keyword: 'keyword',
                                          course_id: 'course_id',
                                          subject_id: 'subject-id',
                                      },
                                  }) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)

    const {item} = useContext(CourseClassContext)
    const can_edit = !!item?.edit
    const [viewAsRole, setViewAsRole] = useState(can_edit ? 'admin' : 'student')
    const [activeTab, setActiveTab] = useState('0')

    const sortBy = useRouteSearchParam(filter_actions.sortBy)


    const course_class_id = getId(item)

    const owner_id = getId(item?.course)

    const owner_type = getType(item?.course)

    const subjects = useMemo(
        () => (item?.class_subjects ?? []).map((cs) => cs.subject).filter(Boolean),
        [item?.class_subjects]
    )

    const [activeSubjectId, setActiveSubjectId] = useState(() => getId(subjects[0]) || null)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
    } = useCourseAttendances({course_class: item})

    const refreshKey = useMemo(
        () => [refresh_token, course_class_id, activeSubjectId].join(''),
        [refresh_token, course_class_id, activeSubjectId]
    )

    const renderContextMenu = useCallback(
        (item) =>
            can_edit
                ? createContextMenu(
                [
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendances',
                        key: AttendanceActionTypes.DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: AttendanceActionTypes.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: AttendanceActionTypes.DELETE,
                    },
                ].filter((e) => item), (key) => {
                    handleAction(key, item)
                },
                {
                    icon: (
                        <div
                            style={{width: 22, height: 22, borderRadius: 999}}
                            className="flex flex-center background hover:background-200 text-color-500 hover:text-color-100 cursor-pointer">
                            <BsThreeDots size={12}/>
                        </div>
                    ),
                }
                )
                : undefined,
        [can_edit]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({subject_id: activeSubjectId})
            onSortChange(sortBy)
        },
        pagerInfo: {
            PaginationMeta: NullAsDefault,
            RenderEntity: React.Fragment,
            apiInfo: course_class_getAttendances_Api,
            query: bindQueryParam({id: course_class_id}),
            renderItem: renderCourseClassAttendance({
                renderContextMenu,
                handleAction,
            }),
        },
        renderSearchBar: NullAsDefault,
        SortByWidget: DateNameSortBy,
        query_params: filter_actions,
        sortHeader: t('list of lesson'),
        withKey: createPagerKey(refreshKey),
        dependencies: [activeSubjectId],
        AdvancedFilter: CouseClassAttendanceFilter,
    })

    const adminTabs = [
        {key: '0', icon: <PiUserListFill size={12}/>, label: t('attendance')},
        {key: '1', icon: <PiChartBarFill size={12}/>, label: t('students')},
    ]

    return (
        <div className="flex flex-col gap-3">
            {can_edit && (
                <CourseClassTabHeader
                    tabs={adminTabs}
                    activeKey={activeTab}
                    onTabChange={setActiveTab}
                    showTabs={viewAsRole === 'admin'}
                    role={viewAsRole}
                    onRoleChange={setViewAsRole}
                />
            )}

            {viewAsRole === 'admin' && can_edit ? (
                <>
                    {activeTab === '0' && (
                        <div className="w-full flex flex-col flex-1 gap-3">
                            <div className="flex items-center justify-between gap-2 py-1">
                                <span className="text-xs text-color-400 italic">{t('create attendance description')}</span>
                                <Button
                                    style={{padding: isSm ? "0 12px" : "0 18px"}}
                                    type="primary"
                                    className="button-rounded-md no-border flex flex-center font-medium text-xs md:text-sm"
                                    onClick={() => handleAction(AttendanceActionTypes.CREATE)}>
                                    {t("create")}
                                </Button>
                            </div>
                            {subjects.length > 0 && (
                                <div className="flex gap-2 flex-wrap">
                                    {subjects.map((s) => (
                                        <button
                                            key={getId(s)}
                                            onClick={() => setActiveSubjectId(getId(s))}
                                            style={{height: 30}}
                                            className={classNames(
                                                'text-xs font-semibold rounded-full transition-colors px-2',
                                                activeSubjectId === getId(s)
                                                    ? 'bg-indigo-600 border-indigo-600 text-white'
                                                    : 'border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500'
                                            )}>
                                            {s?.title}
                                        </button>
                                    ))}
                                </div>
                            )}
                            {activeSubjectId
                                ? <div className="flex flex-col gap-2">{pager_widget}</div>
                                : <EmptyHolder title={t('please select a subject')}/>
                            }
                        </div>
                    )}
                    {activeTab === '1' && (
                        <div className="w-full flex flex-col flex-1">
                            <CourseClassStudentAttendanceStats courseClass={item}/>
                        </div>
                    )}
                </>
            ) : (
                <div className="w-full flex flex-col flex-1 gap-3 py-1">
                    <StudentAttendanceSessionList course_class_id={course_class_id} readOnly={true}/>
                </div>
            )}

            {modal}
        </div>
    )
}

export default CourseClassAttendanceTab
